module.exports = __webpack_public_path__ + "img/icon-arrow-right.d3dd99e1.svg";